<template>
  <admin title="Dados de Acesso" menu="Dados de Acesso">
    <div class="row">
      <div class="col-lg-12 col-xs-12">
        <div class="block_info_white p-2">
          <div class="row">
            <div class="col-lg-5 col-xs-12">
              <div class="form-group mb-0 has-search">
                <span class="fa fa-search ml-2 mt-2 form-control-feedback"></span>
                <input
                  type="text"
                  class="form-control no_border bg_grey"
                  placeholder="Pesquisar por nome"
                />
              </div>
            </div>
            <div class="col-lg-5 col-xs-12 d-flex justify-content-start">
            <div class="col-lg-4 col-xs-12 mt-2">
              <span>Pesquisar por data:</span>
            </div>
              <div class="col-lg-4 col-xs-12">
                <Datepicker
                  input-class="form-control"
                  class="p-0"
                  :format="customFormatter"
                  placeholder="DD/MM"
                  v-model="search_day"
                  :language="ptBR"
                >
                </Datepicker>
                  <button @click="searchDay">asd</button>
              </div>  
            </div>
            <div class="col-lg-2 col-xs-12">
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xs-12">
        <div class="row">
          <div class="col-lg-12">
            <table class="table_jovool mt-3">
              <thead class="headerTable">
                <tr class="text-center">
                  <td class="center">
                    Nome
                 <OrderTable field="" entity="" /> 
                  </td>
                  <td class="center">
                    Último login
                 <OrderTable field="" entity="" /> 
                  </td>
                  <td class="center">
                    Horário
                 <OrderTable field="" entity="" /> 
                  </td>
                  <td class="center">
                    Nome da Empresa
                 <OrderTable field="" entity="" /> 
                  </td>
                </tr>
              </thead>
              <tbody class="position-relative">
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    
  </admin>
</template>

<script>
import vPagination from "vue-plain-pagination";
import OrderTable from "components/OrderTable.vue";
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import { mask } from "vue-the-mask";
import moment from "moment";

  export default {
    components: { vPagination, OrderTable, Datepicker},
    data: () => ({
      test:"",
      ptBR: ptBR,
      search: "",
      field: "",
      order: "",
      params: "",
      access_data: [],
      loading: true,
      search_day: moment().format(),
    }),
    mounted(){
      this.searchDay();
    },
    methods: {
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    searchDay(){
      let params = {};
      if (this.field != ""){
        params["order"] = {};
        params["order"][this.field] = this.order;
      }
      params["search"] = this.search;
      if (this.search == "") {
        params["search"] = "*";
      }
      params["search_day"] = this.search_day
      axios
        .get('/admins/access/search', { params: params }).then((response) => {
          this.access_data = response.data.access_data;
          
        })
      }
    },
  }
</script>
